import { render, staticRenderFns } from "./Hurto.vue?vue&type=template&id=4c49c1e2"
import script from "./Hurto.vue?vue&type=script&lang=js"
export * from "./Hurto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports